import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { AudioRecorder } from 'react-audio-voice-recorder'
import { ModalDialogContainer } from '@common/modal'
import { DialogTitle, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import { useModal } from '@common/GlobalModal'
import {
  Button,
  DialogActions,
  DialogContent,
  TextInput,
} from '@common/material'
import { localizedStrings } from '@core/strings'
import { useFillWorkflow } from '@core/react-query/features/ai/hooks/useFillWorkflow'
import BackdropLoader from '@common/fundamentals/BackdropLoader'
import { useToast } from '@core/toast'
import { useNavigationContext } from '@common/hooks'
import { useTranscribeAudio } from '@core/react-query/features/ai/hooks/useTranscribeAudio'

type AIPrefillWorkflowModalProps = {
  questions: any[]
  onSuccess: (questions: any[]) => void
}

export const AIPrefillWorkflowModal: React.FC<AIPrefillWorkflowModalProps> = ({
  questions,
  onSuccess,
}) => {
  const { organisationId } = useNavigationContext()
  const { hideModal } = useModal()
  const [text, setText] = useState('')
  const mutation = useFillWorkflow()
  const toast = useToast()
  const transcribeMutation = useTranscribeAudio()

  const onRecordingComplete = (blob) => {
    const audioFile = new File([blob], 'recording.webm', { type: 'audio/webm' })

    transcribeMutation.mutate(
      { file: audioFile, organisationId, fileType: 'webm' },
      {
        onSuccess: (data) => {
          console.log(data)
          setText(data.transcript)
        },
        onError: (e) => {
          toast.error(e.message)
        },
      },
    )
  }

  return (
    <ModalDialogContainer>
      <BackdropLoader
        open={mutation.isLoading || transcribeMutation.isLoading}
      />
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        Prefill
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextInput
          multiline={true}
          rows={4}
          fullWidth={true}
          onChange={(e) => {
            setText(e.target.value)
          }}
          value={text}
        />
        <AudioRecorder
          onRecordingComplete={onRecordingComplete}
          audioTrackConstraints={{
            noiseSuppression: true,
            echoCancellation: true,
          }}
        />
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 3 }}>
        <Button
          variant={'contained'}
          onClick={() => {
            mutation.mutate(
              {
                organisationId,
                // NOTE: Currently we don't have a trackingId persisted and returned from the API,
                // so generate a random one every time
                trackingId: uuidv4(),
                text,
                questions,
              },
              {
                onSuccess: (data) => {
                  onSuccess(data)
                  hideModal()
                },
                onError: (e) => {
                  toast.error(e.message)
                },
              },
            )
          }}
        >
          {localizedStrings.submit}
        </Button>
      </DialogActions>
    </ModalDialogContainer>
  )
}
